import React from 'react';
import { useMascot } from './MascotContext';
import MascotCorner from './MascotCorner';
import MascotCenter from './MascotCenter';

export default function Mascot() {
  const { mascotState, dismissMascot } = useMascot();

  if (!mascotState.visible) return null;

  if (mascotState.template === 'center') {
    return <MascotCenter text={mascotState.text} onDismiss={dismissMascot} />;
  }
  return <MascotCorner text={mascotState.text} onDismiss={dismissMascot} />;
}